import {ContentState, EditorState} from "draft-js";
import React from "react";
import {convertFromHTML, convertToHTML} from "draft-convert";

// const styles = {
// 	root: {
// 		fontFamily: '\'Helvetica\', sans-serif',
// 		padding: 20,
// 		width: 600,
// 	},
// 	editor: {
// 		border: '1px solid #ccc',
// 		cursor: 'text',
// 		minHeight: 80,
// 		padding: 10,
// 	},
// 	button: {
// 		marginTop: 10,
// 		textAlign: 'center',
// 	},
// 	link: {
// 		color: "blue"
// 	}
// };

// function findLinkEntities(contentBlock, callback, contentState) {
// 	contentBlock.findEntityRanges(
// 		(character) => {
// 			const entityKey = character.getEntity();
// 			return (
// 				entityKey !== null &&
// 				contentState.getEntity(entityKey).getType() === 'LINK'
// 			);
// 		},
// 		callback
// 	);
// }

// const Link = (props) => {
// 	const {url} = props.contentState.getEntity(props.entityKey).getData();
// 	return (
// 		<a href={url} style={styles.link}>
// 			{props.children}
// 		</a>
// 	);
// };

// function findImageEntities(contentBlock, callback, contentState) {
// 	contentBlock.findEntityRanges(
// 		(character) => {
// 			const entityKey = character.getEntity();
// 			return (
// 				entityKey !== null &&
// 				contentState.getEntity(entityKey).getType() === 'IMAGE'
// 			);
// 		},
// 		callback
// 	);
// }

// const Image = (props) => {
// 	const {
// 		height,
// 		src,
// 		width,
// 	} = props.contentState.getEntity(props.entityKey).getData();
	
// 	return (
// 		<img src={src} height={height} width={width}/>
// 	);
// };

// const decorator = new CompositeDecorator([
// 	{
// 		strategy: findLinkEntities,
// 		component: Link,
// 	},
// 	{
// 		strategy: findImageEntities,
// 		component: Image,
// 	},
// ]);

const advancedFromHtml = convertFromHTML({
	htmlToEntity: (nodeName, node, createEntity) => {
		if (nodeName === 'a') {
			console.log(node);
			return createEntity(
				'LINK',
				'MUTABLE',
				{url: node.href}
			)
		} else if (nodeName === 'img') {
			console.log(node.src);
			return createEntity(
				'IMAGE',
				'IMMUTABLE',
				{src: node.src}
			)
		}
	},
	htmlToBlock: (nodeName, node, lastList, inBlock) => {
		if ((nodeName === 'img' && inBlock !== "atomic") || nodeName === 'figure') {
			console.log(inBlock);
			return "atomic";
		}
	}
});

//Converts a draft editor state into HTML
export function editorFromHtml(html) {
	if (html instanceof EditorState) return html;
	return html ? EditorState.createWithContent(advancedFromHtml(html.toString())) : EditorState.createEmpty();
}

const advancedToHtml = convertToHTML({
	entityToHTML: (entity, originalText) => {
		console.log(entity.type, entity.data);
		if (entity.type === 'LINK') {
			return <a href={entity.data.url}>{originalText}</a>;
		} else if (entity.type === 'IMAGE') {
			return <img src={entity.data.src}/>;
		}
		return originalText;
	}
});

//Converts HTML into a draft editor state
export function editorToHtml(editor) {
	if (typeof editor === "string") return editor;
	return editor ? advancedToHtml(editor.getCurrentContent()) : "";
}

export function editorToText(editor) {
	if (typeof editor === "string") return editor;
	return editor ? editor.getCurrentContent().getPlainText() : "";
}

export function editorFromText(text) {
	if (text instanceof EditorState) return text;
	return text ? EditorState.createWithContent(ContentState.createFromText(text)) : EditorState.createEmpty();
}


// WEBPACK FOOTER //
// ./src/lib/draft.js